import { useEffect } from "react"
import { isEmpty } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"


export default function useValidatorSeeker(dataSend, schema) {
	const errors = useSignal({})
	useEffect(() => {
		schema.validate(dataSend, {
			abortEarly: false
		}).then(() => {
			errors.value = {}
		}).catch(err => {
			errors.value = err.inner.reduce((acc, error) => ({
				...acc,
				[error.path]: error.message
			}), {})
		})
	}, [JSON.stringify(dataSend), JSON.stringify(schema.describe())])

	return {
		isValid: isEmpty(errors.value),
		errorRegistry: errors.value
	}
}